/* import __COLOCATED_TEMPLATE__ from './paywall-modal.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
import type { School } from 'dashboard/types';

interface PaywallModalSignature {
  Element: HTMLDivElement;
  Args: {
    isOpen?: boolean;
    close(e: Event): void;
    currentSchool?: School;
  };
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    PaywallModal: typeof PaywallModal;
  }
}

const PaywallModal = templateOnlyComponent<PaywallModalSignature>();

export default PaywallModal;
